let config = null;

export async function loadConfig() {
  if (config) {
    console.log('Returning cached config:', config);
    return config;
  }
  
  try {
    console.log('Fetching config from config.json...');
    const response = await fetch('/config.json');
    console.log('Config response:', response.status, response.statusText);
    
    if (!response.ok) {
      throw new Error('Failed to load configuration');
    }
    
    config = await response.json();
    console.log('Config loaded successfully:', config);
    return config;
  } catch (error) {
    console.error('Error loading configuration:', error);
    throw error;
  }
}

export function getConfig() {
  if (!config) {
    throw new Error('Configuration not loaded. Call loadConfig() first.');
  }
  return config;
} 